export { default } from "./Emission";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/Emission/index.js